module.exports = __webpack_public_path__ + "static/media/Peoples.ae003ec9.jpg";